<script setup lang="ts">
import { hasFlag } from 'country-flag-icons'
import { computed, h, ref, watch } from 'vue'

export interface FlagProps {
  flag: string
  variant?: 'square' | 'rectangle'
}

const props = withDefaults(defineProps<FlagProps>(), {
  variant: 'square'
})

const svgFlag = ref('')
const viewBox = ref<string | null>(null)

function isFlag(flag: string): flag is 'US' {
  return hasFlag(flag)
}

watch(
  () => props.flag,
  async (newFlag, oldFlag) => {
    if (newFlag !== oldFlag) {
      try {
        if (isFlag(newFlag)) {
          const suffixPath = props.variant === 'square' ? '1x1' : '3x2'
          const svg =
            props.variant === 'square'
              ? (await import(`country-flag-icons/string/1x1`))[newFlag]
              : (await import(`country-flag-icons/string/3x2`))[newFlag]
          const parser = new DOMParser()
          const flagDoc = parser.parseFromString(svg, 'image/svg+xml')
          const firstChild = flagDoc.firstChild as SVGElement
          if (firstChild) {
            viewBox.value = firstChild.getAttribute('viewBox')
            svgFlag.value = firstChild.innerHTML
          }
        }
      } catch (error) {}
    }
  },
  { immediate: true }
)

const component = computed(() =>
  h('svg', {
    innerHTML: svgFlag.value,
    viewBox: viewBox.value,
    xmlns: 'http://www.w3.org/2000/svg'
  })
)
</script>
<template>
  <component :is="component" v-if="viewBox && svgFlag" />
</template>
